<!-- new theme implementation starts -->
<div class="border card-accord  mb15">
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="tablest1 table-layout">
          <thead>
            <tr>
              <th style="width: 5%" scope="col" translate>lblDemand</th>
              <th style="width: 15%" scope="col" sortable="Name" translate>lblShortDescription</th>
              <th style="width: 25%" scope="col" sortable="Address1" translate>lblCustomerRequirement</th>
              <th style="width: 15%" scope="col" sortable="Landline" translate>lblComments</th>
              <th style="width: 15%" scope="col" sortable="Landline" translate>lblUser</th>
              <th style="width: 15%" scope="col" sortable="Landline" translate>lblDate</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="response?.length>0; else load_else">
              <tr *ngFor="let comments of response; let i=index">
                <td>{{ comments.appointmentDemandId }}</td>
                <td>
                  <ngb-highlight [result]="comments.shortDescription"></ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="comments.customerRequirement"></ngb-highlight>
                </td>
                <td class="wrap">
                  <ngb-highlight [result]="comments.comments"></ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="comments.user"></ngb-highlight>
                </td>
                <td>
                  {{ comments.updatedDate | date:'short' }}
                </td>
              </tr>
            </ng-container>
            <ng-template #load_else>
              <tr>
                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<!-- new theme implementation ends -->